import { __extends as o } from '../../external_external_node_modules/tslib/tslib.es6.js';
import { BaseFormatter as s } from '../base.js';
import { NumberFormatter as n$1 } from '../Number/index.js';
import { getRulePicker as r } from '../../utils/getRulePicker.js';
import t from './rules/index.js';

var n=function(t$1){function n(r,i){var o=t$1.call(this,r,i)||this;return o.number=new n$1(r),o}return o(n,t$1),n.prototype.format=function(r$1){var t$1=r(this.joinRulesWithDefault(t),this.language);return ((null==t$1?void 0:t$1())||"{input}%").replace("{input}",this.number.format(r$1))},n}(s);

export { n as PercentFormatter };
//# sourceMappingURL=index.js.map
